import { IColumn, Icon } from "@fluentui/react";
import { IFileUploadItem, Subtitle } from "ioip-base/lib/common";
import React from "react";
import { Sede } from "../../classes/shared";
import { ensureFetch, showConfirmation, showError, successToast } from "../../ioip/sdk/base";
import { PqrWebService } from "../../services/services";
import { FileSelectorSede } from "./FileSelectorSede";
import { Guid } from "@ioip/core/lib";

export interface IReFileUploaderProps {
    title: string;
    attachments: IFileUploadItem[];
    onAttachmentsChanged: (files: IFileUploadItem[]) => void;
    onRetryCompleted: (file: IFileUploadItem) => void;
    radicadoId: number;
    allowRemove: boolean;
    service: PqrWebService;
    sessionId: string;
}

const ReFileUploader = (props: IReFileUploaderProps): JSX.Element => {

    const items = props.attachments || [];
    const extensions = Sede.Shared.Context.AllowedExtensions;

    const onRemoveAttachment = (item: IFileUploadItem) => {
        showConfirmation('Eliminar archivo', `¿Está seguro que desea eliminar el archivo ${item.name}?`, () => {
            const api = Guid.isValid(props.sessionId)
                ? props.service.deleteAnonymousChunkDocumentAsync(props.sessionId, item.data.IdDocumentoRadicadoEntrada)
                : props.service.deleteChunkDocumentAsync(item.data.IdDocumentoRadicadoEntrada);
            ensureFetch(api, () => {
                props.onAttachmentsChanged(props.attachments.filter(o => o.data?.IdDocumentoRadicadoEntrada != item.data.IdDocumentoRadicadoEntrada));
                successToast('Archivo eliminado');
            });
        });
    }

    const onDownloadAttachmentAsync = async (item: IFileUploadItem) => {
        // if (item.data?.IdDocumentoRadicadoEntrada > 0) {
        //     const response: Blob = props.isAttachment
        //         ? await props.service.downloadAnexoAsync(props.radicadoId, item.data.IdDocumentoRadicadoEntrada)
        //         : await props.service.downloadDocumentAsync(props.radicadoId, item.data.IdDocumentoRadicadoEntrada);
        //     const file = getFileWithMimeType(response, Ioip.File.GetExtension(item.name));
        //     $_.utils.downloadBlob(file, item.name);
        // }
    }

    const onRety = (file: IFileUploadItem, newName: string, newSize: number) => {

        const isSameFile = file.name === newName && file.size === newSize;
        if (!isSameFile) {
            showError(`El archivo a cargar no es el mismo.\nNombre esperado: ${file.name}\nTamaño esperado: ${file.size}`);
        }

        return {
            cancel: !isSameFile,
            nextChunk: file.data.CurrentChunk,
            onAppend: (buffer: Blob) => {
                return Guid.isValid(props.sessionId)
                    ? props.service.appendAnonymousChunkContentAsync(props.sessionId, file.data.IdDocumentoRadicadoEntrada, buffer)
                    : props.service.appendChunkContentAsync(file.data.IdDocumentoRadicadoEntrada, buffer);
            },
            onComplete: () => {
                file.error = false;
                props.onRetryCompleted(file);
                successToast(`Archivo ${newName} cargado correctamente`);
            }
        };

    }

    const onCreate = async (name: string, size: number, uploadId: string) => {
        try {
            const creationResult = Guid.isValid(props.sessionId)
                ? await props.service.createAnonymousChunkDocumentAsync(props.sessionId, { Length: size, Name: name })
                : await props.service.createChunkDocumentAsync({ Length: size, Name: name });
            return {
                cancel: false,
                onAppend: (buffer: Blob) => {
                    return Guid.isValid(props.sessionId)
                        ? props.service.appendAnonymousChunkContentAsync(props.sessionId, creationResult.DocumentId, buffer)
                        : props.service.appendChunkContentAsync(creationResult.DocumentId, buffer);
                },
                onComplete: (setData: (data: any) => void) => {
                    setData({ IdDocumentoRadicadoEntrada: creationResult.DocumentId })
                    successToast(`Archivo ${name} cargado correctamente`);
                }
            }
        } catch (ex) {
            showError((ex as any).ExceptionMessage || (ex as any).exceptionMessage);
            const attachments = (props.attachments || []).filter(o => o.uploadId != uploadId);
            props.onAttachmentsChanged(attachments);
            return {
                cancel: true,
                onAppend: null,
                onComplete: null
            }
        }
    }

    const onChanged = (files: IFileUploadItem[]) => {
        props.onAttachmentsChanged(files || [])
    }

    const showFile = (documentId: number, isAttachment: boolean) => {
        // ensureFetch(props.service.getViewerUrlAsync(props.radicadoId, documentId, isAttachment), url => {
        //     $_.openFileViewer(url);
        // })
    }

    const columns: IColumn[] = [];
    if (props.allowRemove) {
        columns.push({
            key: 'remove',
            name: '',
            fieldName: '',
            minWidth: 20,
            maxWidth: 20,
            isResizable: false,
            onRender: (item: IFileUploadItem) => {
                if (item.data?.IdDocumentoRadicadoEntrada > 0) {
                    return <Icon
                        iconName={'Delete'}
                        onClick={() => onRemoveAttachment(item)}
                        style={{ cursor: 'pointer' }}
                    />
                }
                return <></>
            }
        });
    }

    const allowCreate = true;

    return <>
        <Subtitle text={props.title} />
        <FileSelectorSede
            allowCreate={allowCreate}
            files={items || []}
            onChanged={onChanged}
            multiple={true}
            allowedExtensions={extensions}
            errorMessage=""
            onCreate={onCreate}
            onRetry={onRety}
            onClick={(file) => showFile(file.data?.IdDocumentoRadicadoEntrada, true)}
            columns={columns}
            onError={error => showError(error)}
            onShowMessage={(message, title) => showError(message)}
        />
    </>

}

export default ReFileUploader;